import { render, staticRenderFns } from "./DocumentMoveDialog.vue?vue&type=template&id=ef23a6d8"
import script from "./DocumentMoveDialog.vue?vue&type=script&lang=js"
export * from "./DocumentMoveDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentMoveDialog.vue?vue&type=style&index=0&id=ef23a6d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports